import { commonEnvObject } from 'projects/visa-platform/src/environments/commonEnvObject';
import { Environment } from 'projects/visa-platform/src/environments/environment.interface';

import { languageSpecificConfigs } from './gcc/en';

export const environment: Environment = {
  ...commonEnvObject.production,
  ...commonEnvObject.visaGcc,
  clientId: '58cfab7e-ae9a-455f-a964-8fb7257aff52',
  projectId: 'fb287a01-0c2d-4499-b6c0-4b018c12d18f',
  webUrl: 'https://visagccbenefits.poshvine.com',
  recaptchaPublicId: '6Le9_vIqAAAAAN27wJ9U5VlYXQWPO31rn3CCFVlo',
  staticTextContents: languageSpecificConfigs,
};
